import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribersOnly from '../../../../ActionBar/_partials/SubscribersOnly';
import { useScrollToDeviationComments } from '../../../../DeviationPage/_partials/Comments/useScrollToDeviationComments';
import Stats from '../../../../Stats';
import s from './StatBlock.scss';
/** Controls rendering stats (and SubscribersOnly on mobile) for most devpages */ export const StatBlock = ({ deviation, className })=>{
    const isMobile = useContext(MobileContext);
    const { tier } = useSubscriptionTier(deviation);
    const withTierInfo = !!tier;
    const scrollToDeviationComments = useScrollToDeviationComments();
    if (isMobile && withTierInfo) {
        // the only difference between the following block and the one below
        // is designs need to have the subscribers only here on mobile
        // and the css control on how that and the stats and badges wrap
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], className)
        }, /*#__PURE__*/ React.createElement(SubscribersOnly, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(Stats, {
            className: s['stats'],
            badgelistClassName: s['badges'],
            deviation: deviation,
            withViewCount: false,
            withSubscriberCount: true,
            onCommentClick: scrollToDeviationComments
        }));
    }
    return /*#__PURE__*/ React.createElement(Stats, {
        className: className,
        deviation: deviation,
        withViewCount: !withTierInfo,
        withPrivateCollectionsCount: !withTierInfo,
        withSubscriberCount: withTierInfo,
        onCommentClick: scrollToDeviationComments
    });
};
StatBlock.displayName = 'StatBlock';
export default StatBlock;

//# sourceMappingURL=StatBlock.js.map